import type { JSX } from 'react';
import { Link } from 'react-router';
import { useLegal } from '../brand/legal-context.js';

/**
 * Legal links in the footer. Holds neither its own labels nor paths: brand
 * document sets differ, and only the Russian one has an "Оферта".
 */
export function LegalLinks({ compact = false }: { readonly compact?: boolean }): JSX.Element {
  const legal = useLegal();

  return (
    <nav
      aria-label={legal.ui.footerNavLabel}
      className={compact ? 'flex flex-wrap justify-center gap-x-4 gap-y-2' : 'flex flex-wrap gap-4'}
    >
      {legal.footerLinks.map((link) => (
        <Link key={link.to} to={link.to}>
          {link.label}
        </Link>
      ))}
    </nav>
  );
}
